"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isLayer = exports.layerRuleSet = exports.PRINT_TYPES_WITH_BLACK_MASK = exports.LAYER_PRINT_TYPE_TIPON = exports.LAYER_PRINT_TYPE_DIGITAL_FOIL = exports.LAYER_PRINT_TYPE_FOIL_STAMP = exports.LAYER_PRINT_TYPE_LETTERPRESS = exports.LAYER_PRINT_TYPE_DIGITAL = exports.isLayerType = exports.LAYER_TYPE_MASK = exports.LAYER_TYPE_CUTOUT = exports.LAYER_TYPE_ADDRESS = exports.LAYER_TYPE_EDITABLE_DESIGN_ASSET = exports.LAYER_TYPE_USER_PHOTO = exports.LAYER_TYPE_EDITABLE_TEXT = exports.LAYER_TYPE_DESIGN_ASSET = void 0;
const typeguard_1 = require("../../types/typeguard");
exports.LAYER_TYPE_DESIGN_ASSET = 'design_asset';
exports.LAYER_TYPE_EDITABLE_TEXT = 'editable_text';
exports.LAYER_TYPE_USER_PHOTO = 'user_photo';
exports.LAYER_TYPE_EDITABLE_DESIGN_ASSET = 'editable_design_asset';
exports.LAYER_TYPE_ADDRESS = 'address';
exports.LAYER_TYPE_CUTOUT = 'cutout';
// There is no corresponding interface for mask layers, but it feels unsafe to remove it from the checks below
// because consuming code may rely on it somehow and maybe there are mask layers in Hammer.
exports.LAYER_TYPE_MASK = 'mask';
const isLayerType = input => [exports.LAYER_TYPE_DESIGN_ASSET, exports.LAYER_TYPE_EDITABLE_TEXT, exports.LAYER_TYPE_USER_PHOTO, exports.LAYER_TYPE_EDITABLE_DESIGN_ASSET, exports.LAYER_TYPE_ADDRESS, exports.LAYER_TYPE_CUTOUT, exports.LAYER_TYPE_MASK].includes(input);
exports.isLayerType = isLayerType;
exports.LAYER_PRINT_TYPE_DIGITAL = 'digital';
exports.LAYER_PRINT_TYPE_LETTERPRESS = 'letterpress';
exports.LAYER_PRINT_TYPE_FOIL_STAMP = 'foil_stamp';
exports.LAYER_PRINT_TYPE_DIGITAL_FOIL = 'digital_foil';
exports.LAYER_PRINT_TYPE_TIPON = 'tipon';
exports.PRINT_TYPES_WITH_BLACK_MASK = [exports.LAYER_PRINT_TYPE_DIGITAL_FOIL, exports.LAYER_PRINT_TYPE_FOIL_STAMP, exports.LAYER_PRINT_TYPE_LETTERPRESS];
const isValidPrintType = printType => [exports.LAYER_PRINT_TYPE_DIGITAL, exports.LAYER_PRINT_TYPE_DIGITAL_FOIL, exports.LAYER_PRINT_TYPE_FOIL_STAMP, exports.LAYER_PRINT_TYPE_LETTERPRESS, exports.LAYER_PRINT_TYPE_TIPON].includes(printType);
exports.layerRuleSet = {
  id: typeguard_1.isNonEmptyString,
  type: exports.isLayerType,
  width: typeguard_1.isNumber,
  height: typeguard_1.isNumber,
  x: typeguard_1.isNumber,
  y: typeguard_1.isNumber,
  zIndex: (0, typeguard_1.optional)(typeguard_1.isNumber),
  rotate: (0, typeguard_1.optional)(typeguard_1.isNumber),
  placeholder: (0, typeguard_1.optional)(typeguard_1.isBool),
  callable: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  printType: (0, typeguard_1.optional)(isValidPrintType)
};
const isLayer = l => (0, typeguard_1.isType)(l, exports.layerRuleSet);
exports.isLayer = isLayer;